import { uid } from 'radash';
import { proxy } from 'valtio';

export type Suggestion = {
    id: string;
    type: 'addConnectionProtection';
    data: object;
    cleared: boolean;
    clearable: boolean;
};

const SuggestionService = {
    state: proxy({
        suggestions: [] as Suggestion[],
    }),

    suggest: (type: Suggestion['type'], data: Suggestion['data'] = {}) => {
        const id = uid(5);

        const counts: Record<string, number> = {};

        SuggestionService.state.suggestions.toReversed().forEach((suggestion) => {
            counts[suggestion.type] = counts[suggestion.type] || 0;
            counts[suggestion.type] += 1;

            if (counts[suggestion.type] >= 3 && suggestion.type === type) {
                suggestion.cleared = true;
            }
        });

        SuggestionService.state.suggestions.push({
            id,
            type,
            data,
            cleared: false,
            clearable: true,
        });

        SuggestionService.scheduleClear(id);

        return id;
    },

    get: (id: string) => {
        const { suggestions } = SuggestionService.state;

        return suggestions.find((suggestion) => suggestion.id === id) || null;
    },

    clear: (id: string, force = false) => {
        const suggestion = SuggestionService.get(id);

        if (suggestion && (suggestion.clearable || force)) {
            suggestion.cleared = true;
        }
    },

    scheduleClear: (id: string, delay = 10_000) => {
        setTimeout(() => {
            SuggestionService.clear(id);
        }, delay);
    },
};

export { SuggestionService };
